import React from "react";

import { FloatingBarButton } from "./floating-bar-button";

import "./floating-bar-icon.css";
import { Icon } from "../icon";

export function FloatingBarIcon({
	iconName,
	children, // Alow to pass a cutom icon as children, if not provided, like an svg
	...props
}: React.ComponentProps<typeof FloatingBarButton> & { iconName?: string }) {
	return (
		<FloatingBarButton className="floating-bar-icon" {...props}>
			{children === undefined ? <Icon iconName={iconName} /> : children}
		</FloatingBarButton>
	);
}
